import React, { useEffect, useState, useRef } from "react";
import {
  GoogleMap,
  Marker,
  useJsApiLoader,
  InfoWindow,
} from "@react-google-maps/api";
import Geocode from "react-geocode";
import GoogleMarkerIcon from "../../assets/images/google-marker-icon.svg";

const googleApiKey = process.env.REACT_APP_MAP_API_KEY;
Geocode.setApiKey(googleApiKey);
Geocode.enableDebug();

const containerStyle = {
  width: "100%",
  height: "100%",
};

interface Position {
  lat: number;
  lng: number;
}

const ContactUsMap: React.FC = () => {
  const markerPosition = {
    lat: 41.318524940300094,
    lng: -72.24465731804881,
  };
  const address = "10 Liberty Way, Niantic, CT 06357";
  const [selectedMarkerAddress, setSelectedMarkerAddress] = useState("");

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: googleApiKey,
  });

  // Display address information on click on marker
  const handleMarkerClick = (address) => {
    setSelectedMarkerAddress(address);
  };

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      mapContainerClassName="contact-map"
      center={markerPosition}
      onClick={() => setSelectedMarkerAddress("")}
      zoom={15}
      options={{
        draggable: true,
        zoomControl: false,
        fullscreenControl: false,
        disableDefaultUI: true,
      }}
    >
      <Marker
        position={markerPosition}
        icon={GoogleMarkerIcon}
        onClick={() => handleMarkerClick(address)}
      />
      {selectedMarkerAddress && (
        <InfoWindow
          position={markerPosition}
          onCloseClick={() => setSelectedMarkerAddress("")}
        >
          <div>{selectedMarkerAddress}</div>
        </InfoWindow>
      )}
    </GoogleMap>
  ) : (
    <></>
  );
};

export default ContactUsMap;
